import memoize from 'fast-memoize';

/**
 * Formatting the currency
 * @param amount number
 * @returns amount in currency
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const currencyFormat = memoize((amount: number) => {
    return amount?.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    });
});
